module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "sutra-container"
  }, [_c('div', {
    ref: "content",
    staticClass: "sutra-content",
    style: (_vm.contentStyle)
  }, [_c('div', {
    staticClass: "sutra-text-flow"
  }, [_c('span', {
    staticClass: "sutra-title"
  }, [_vm._v("《金刚经》")]), _vm._v(" "), _c('span', {
    staticClass: "history-text"
  }, [_vm._v(_vm._s(_vm.historyText))]), _vm._v(" "), (_vm.activeChar) ? _c('span', {
    ref: "activeWrapper",
    staticClass: "active-char-wrapper"
  }, [_c('span', {
    staticClass: "active-char",
    style: (_vm.activeCharStyle)
  }, [_vm._v(_vm._s(_vm.activeChar))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c3a6a70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sutra/index.vue
// module id = 169
// module chunks = 1